//
//
//
//
//
//

export default {
  name: 'AppMain',
}



// WEBPACK FOOTER //
// ./src/pages/layout/AppMain.vue